<template>
  <div>
    <div class="container-fluid bg-white mk-business-dash-fe">
      <div class="container">
        <div class="row py-3 d-flex justify-content-between">
          <div class="col-12 d-flex justify-content-between align-items-center py-3">
            <div class="d-flex justify-content-start align-items-center">
              <h2 class="mb-0">{{business.name}}</h2>
              <el-tag
                class="ml-3 status-pill"
                :type="business_status.tag_type"
              >{{business_status.name}}</el-tag>
            </div>
            <a :href="'/businesses/'+business.id">
              <strong>Go to Customer Profile</strong>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="business_status.name == 'Approved'" class="container-fluid">
      <div class="row py-3 mx-3 mt-4 bg-white">
        <div class="col-12 d-flex justify-content-between">
          <div>
            <h2>Financing Status</h2>
            <p>Re-evaluation required: {{business.evaluate_at ? moment(business.evaluate_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY') : 'N/A'}}</p>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column align-items-center mx-2">
              <p class="mb-1">
                <strong>Limit</strong>
              </p>
              <p
                class="mb-0 px-3 py-2 bg-ott text-center"
                style="min-width: 100px;"
              >{{business.formatted_finance_capacity}}</p>
            </div>

            <div class="d-flex flex-column align-items-center mx-2">
              <p class="mb-1">
                <strong>Drawn</strong>
              </p>
              <p
                class="mb-0 px-3 py-2 bg-ott text-center"
                style="min-width: 100px;"
              >{{business.formatted_amount_outstanding}}</p>
            </div>

            <div class="d-flex flex-column align-items-center mx-2">
              <p class="mb-1">
                <strong>Available</strong>
              </p>
              <p
                class="mb-0 px-3 py-2 bg-ott text-center"
                style="min-width: 100px;"
              >{{business.formatted_available_capacity}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row py-3 mt-4 mx-3 bg-white">
        <div class="col-12 d-flex align-items-center justify-content-between">
          <h3 class="mb-0">Livestock Purchases</h3>
          <div>
            <el-button class="btn-light-blue" type="primary" plain>Export</el-button>
            <el-button class="btn-light-blue" type="primary" plain v-b-modal.modal-1>New</el-button>
            <b-modal centered size="xl" id="modal-1" ref="my-modal" title="New Livestock Purchase">
              <business-purchase-modal
                @onAdd="handlePurchaseAdded"
                :business="business"
                @close="$refs['my-modal'].hide()"
                :livestock_classes="livestock_classes"
                :sexes="sexes"
                :hpg_categories="hpg_categories"
                :end_markets="end_markets"
              ></business-purchase-modal>
              <div slot="modal-footer"></div>
            </b-modal>
          </div>
        </div>

        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Term</th>
                  <th scope="col">Head</th>
                  <th scope="col">$/Head</th>
                  <th scope="col">DOS</th>
                  <th scope="col">Value</th>
                  <th scope="col">DOF</th>
                  <th scope="col">Status</th>
                  <th scope="col">Reconciled At</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(purchase, index) in purchases.data" :key="index">
                  <td>{{purchase.id}}</td>
                  <td>{{purchase.term}}</td>
                  <td>{{purchase.number_of_head}}</td>
                  <td>${{Number(purchase.per_head_price / 100).toFixed(2)}}</td>
                  <td>{{purchase.date_of_sale ? moment(purchase.date_of_sale, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}}</td>
                  <td>${{purchase.dollar_value}}</td>
                  <td>{{purchase.days_on_feed}}</td>
                  <td>
                    <el-tag
                      :type="getPurchaseStatus(purchase.purchase_status_id).tag_type"
                      class="status-pill"
                    >{{getPurchaseStatus(purchase.purchase_status_id).name}}</el-tag>
                  </td>
                  <td>{{purchase.reconciled_at}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>
            <pagination
              :limit="4"
              :show-disabled="true"
              :data="purchases"
              @pagination-change-page="getPurchases"
            >
              <span slot="prev-nav">
                <i class="fas fa-chevron-left"></i>
              </span>

              <span slot="next-nav">
                <i class="fas fa-chevron-right"></i>
              </span>
            </pagination>
          </div>
        </div>
      </div>

      <div class="row mt-4 mx-3">
        <div class="col-12 py-3 d-flex align-items-center justify-content-between bg-white">
          <div>
            <h2>Livestock Sales</h2>
          </div>

          <div>
            <el-button class="btn-light-blue" type="primary" plain>Export</el-button>
            <el-button class="btn-light-blue" type="primary" plain v-b-modal.modal-2>New</el-button>
            <b-modal centered size="xl" id="modal-2" ref="my-modal-2" title="New Livestock Sale">
              <business-sale-modal
                @close="$refs['my-modal-2'].hide()"
                @onAdd="handleSaleAdded"
                :livestock_classes="livestock_classes"
                :business="business"
                :sexes="sexes"
                :hpg_categories="hpg_categories"
                :end_markets="end_markets"
              ></business-sale-modal>
              <div slot="modal-footer"></div>
            </b-modal>
          </div>
        </div>

        <div class="col-12 bg-white">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Head</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sale, index) in sales.data" :key="index">
                  <td>{{sale.id}}</td>
                  <td>${{Number(sale.dollar_value).toFixed(2)}}</td>
                  <td>{{sale.number_of_head}}</td>
                  <td>
                    <el-tag
                      :type="getSaleStatus(sale.sale_status_id).tag_type"
                    >{{getSaleStatus(sale.sale_status_id).name}}</el-tag>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>
            <pagination
              :limit="4"
              :show-disabled="true"
              :data="sales"
              @pagination-change-page="getSales"
            >
              <span slot="prev-nav">
                <i class="fas fa-chevron-left"></i>
              </span>

              <span slot="next-nav">
                <i class="fas fa-chevron-right"></i>
              </span>
            </pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container-fluid">
      <div class="row py-3 mx-3 mt-4 bg-white">
        <div class="col-12 d-flex justify-content-between">
          <div>
            <h2>Producer Not Approved</h2>
            <p>This producer is still being evaluated.</p>
          </div>
        </div>
      </div>
    </div>

    <business-sale-modal
      v-if="showSalesModal"
      @close="showSalesModal=false"
      @onAdd="handleSaleAdded"
      :business="business"
      :sexes="sexes"
      :hpg_categories="hpg_categories"
      :end_markets="end_markets"
    ></business-sale-modal>
  </div>
</template>




<script>
import Business from "../../models/Business";
import Sale from "../../models/Sale";
import Purchase from "../../models/Purchase";
import PurchaseStatuses from "../../../constants/PurchaseStatuses.js";
import BusinessStatuses from "../../../constants/BusinessStatuses.js";
import SaleStatuses from "../../../constants/SaleStatuses.js";

export default {
  props: {
    initial_business: {
      type: Object
    },
    business_types: {
      type: Array
    },
    livestock_classes: {
      type: Array
    },
    sexes: {
      type: Array
    },
    hpg_categories: {
      type: Array
    },
    end_markets: {
      type: Array
    }
  },
  mounted() {
    this.getPurchases();
    this.getSales();
  },
  computed: {
    business_statuses() {
      return Object.keys(BusinessStatuses).map(key => {
        return BusinessStatuses[key];
      });
    },
    business_status() {
      return this.business_statuses.filter(
        x => x.id == this.business.business_status_id
      )[0];
    }
  },
  data() {
    return {
      business: this.initial_business,
      purchases: {},
      showPurchaseModal: false,
      showSalesModal: false,
      sales: {}
    };
  },
  methods: {
    async getPurchases(page = 1) {
      this.purchases = await Purchase.include("purchaseStatus,purchaseAssets")
        .orderBy("-created_at")
        .for(new Business(this.business))
        .page(page)
        .get();
    },
    async getSales(page = 1) {
      this.sales = await Sale.include("saleStatus")
        .orderBy("-created_at")
        .for(new Business(this.business))
        .page(page)
        .get();
    },
    getPurchaseStatus(purchase_status_id) {
      let statuses = Object.keys(PurchaseStatuses).map(key => {
        return PurchaseStatuses[key];
      });

      return statuses.filter(x => x.id == purchase_status_id)[0];
    },
    getSaleStatus(sale_status_id) {
      let statuses = Object.keys(SaleStatuses).map(key => {
        return SaleStatuses[key];
      });

      return statuses.filter(x => x.id == sale_status_id)[0];
    },
    handlePurchaseAdded(purchase) {
      this.purchases.data.unshift(purchase);
    },
    handleSaleAdded(sale) {
      this.sales.data.unshift(sale);
    }
  }
};
</script>